module.exports = __webpack_public_path__ + "818b8ce9b71c4b65ebc1db785f088aa5.pdf";